module.exports = __webpack_public_path__ + "img/0201.f658ded7.png";